/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Vb365JobSessionLog } from './vb365JobSessionLog';
import { Vb365JobItemComposed } from './vb365JobItemComposed';
import { Vb365BackupJobSchedulePolicy } from './vb365BackupJobSchedulePolicy';


export interface Vb365BackupJob { 
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 backup job.
     */
    readonly instanceUid?: string;
    /**
     * Name of a Veeam Backup for Microsoft 365 backup job.
     */
    name: string;
    /**
     * Description of a Veeam Backup for Microsoft 365 backup job.
     */
    description?: string | null;
    /**
     * UID assigned to a backup repository. >When patching job target repository, you can use the `GetVb365BackupJobAvailableBackupRepositories` operation to retrieve a list of available repositories. 
     */
    repositoryUid: string;
    /**
     * Name of a backup repository.
     */
    readonly repositoryName?: string;
    /**
     * UID assigned to a Microsoft organization.
     */
    readonly vb365OrganizationUid?: string;
    /**
     * UID assigned to a Veeam Service Provider Console organization.
     */
    readonly vspcOrganizationUid?: string | null;
    /**
     * Name of a Veeam Service Provider Console organization.
     */
    readonly vspcOrganizationName?: string | null;
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 server.
     */
    readonly vb365ServerUid?: string;
    /**
     * Name Of a Veeam Backup for Microsoft 365 server.
     */
    readonly vb365ServerName?: string;
    /**
     * Date and time of the latest job run.
     */
    readonly lastRun?: string | null;
    /**
     * Date and time of the next scheduled job run.
     */
    readonly nextRun?: string | null;
    /**
     * Indicates whether a Veeam Backup for Microsoft backup job is enabled.
     */
    isEnabled?: boolean;
    /**
     * Indicates whether a backup copy job can be created for the Veeam Backup for Microsoft 365 backup job.
     */
    readonly isCopyJobAvailable?: boolean;
    /**
     * Type of a Veeam Backup for Microsoft 365 backup job.
     */
    backupType?: Vb365BackupJobBackupType | null;
    /**
     * Status of the latest job run.
     */
    readonly lastStatus?: Vb365BackupJobLastStatus | null;
    /**
     * Details on the latest job run.
     */
    readonly lastStatusDetails?: string;
    /**
     * The list of last job session logs.
     */
    readonly lastErrorLogRecords?: Array<Vb365JobSessionLog>;
    /**
     * Array of backup job items.
     */
    selectedItems?: Array<Vb365JobItemComposed>;
    /**
     * Array of items excluded from the backup job.
     */
    excludedItems?: Array<Vb365JobItemComposed>;
    /**
     * Backup job schedule settings.
     */
    schedulePolicy?: Vb365BackupJobSchedulePolicy | null;
}
export enum Vb365BackupJobBackupType {
    Unknown = 'Unknown',
    EntireOrganization = 'EntireOrganization',
    SelectedItems = 'SelectedItems'
};
export enum Vb365BackupJobLastStatus {
    Unknown = 'Unknown',
    Stopped = 'Stopped',
    Running = 'Running',
    Success = 'Success',
    Failed = 'Failed',
    Warning = 'Warning',
    NotConfigured = 'NotConfigured',
    Disconnected = 'Disconnected',
    Queued = 'Queued',
    Starting = 'Starting',
    Stopping = 'Stopping',
    Deleting = 'Deleting'
};



